import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=73ae040e&scoped=true&"
import script from "./BannerComponent.vue?vue&type=script&lang=ts&"
export * from "./BannerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae040e",
  null
  
)

export default component.exports